import { Injectable } from "@angular/core";
import { SwUpdate } from "@angular/service-worker";
import { interval } from "rxjs";

@Injectable()
export class CheckForUpdateService {
  constructor(updates: SwUpdate) {
    sessionStorage.setItem("updateAvailable", "false");
    setTimeout(() => {
      updates.checkForUpdate();
    }, 10000);

    const everyHour$ = interval(1 * 60 * 60 * 1000);
    everyHour$.subscribe(() => {
      updates.checkForUpdate();
    });
  }
}
@Injectable()
export class CheckForUpdateServiceMock {
  constructor() {}
}
